var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-3 min-w-0 w-full"},[_c('div',{staticClass:"display-1"},[_vm._v("Yleiset kulut")]),_c('receipt-table',{attrs:{"source":"general"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }